import { Component } from 'react';
import { logError } from '../lib/logError';

export class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, info) {
        logError(error, { phase: 'ErrorBoundary', componentStack: info?.componentStack });
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{ padding: '2rem', textAlign: 'center', color: '#ef4444' }}>
                    <p style={{ fontWeight: 600, marginBottom: '0.5rem' }}>Algo deu errado.</p>
                    <p style={{ fontSize: '0.875rem', color: '#94a3b8', marginBottom: '1rem' }}>
                        {this.state.error?.message || 'Erro inesperado. Recarregue a página.'}
                    </p>
                    <button
                        onClick={() => window.location.reload()}
                        style={{ padding: '0.5rem 1rem', background: '#1e293b', border: '1px solid #334155', borderRadius: '0.5rem', color: '#e2e8f0', cursor: 'pointer' }}
                    >
                        Recarregar
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}
